import {
  fork,
  put,
  takeLatest,
  delay,
} from 'redux-saga/effects';
import { captureError, captureMessage } from '@/services/error-sender';
import {
  ERROR_PASS_REQUEST,
  ERROR_UPDATE_REQUEST,
  ERROR_UPDATE_SUCCESS,
  ERROR_RESET_REQUEST,
  VALIDATION_ERROR_REQUEST,
  VALIDATION_ERROR_SUCCESS,
} from '@/action-types/error';

export function* errorPass(params: {
  type: string;
  error?: any;
  message?: string;
  tags: string[];
}) {
  if (params.error) {
    yield fork(captureError, params.error, params.tags);
  } else if (params.message) {
    yield fork(captureMessage, params.message, params.tags);
  }
}

export function* errorUpdate(params: {
  isActive: boolean;
  errorData: {
    errorText?: string;
    graphQLErrors: any;
    networkError: any;
  };
}) {
  const errors = [];
  const gqlErrors = (params?.errorData?.graphQLErrors ?? []);
  const networkErrors = (params?.errorData?.networkError?.message ?? '');

  if (gqlErrors.length) {
    gqlErrors.forEach((e: {
      extensions: {
        detail: string;
        message: string;
      };
      message: string;
    }) => {
      errors.push(e.extensions.detail || e.extensions.message || e.message);
    });
  } else if (networkErrors) {
    errors.push(networkErrors);
  } else if (params.errorData && params.errorData.errorText) {
    errors.push(params.errorData.errorText);
  } else {
    errors.push('Something went wrong');
  }

  yield put({
    type: ERROR_UPDATE_SUCCESS,
    errors,
  });
  yield delay(3000);
  yield put({ type: ERROR_RESET_REQUEST });
}

export function* validationError(params: {
  isActive: boolean;
  errorData: {
    errorText?: string;
    graphQLErrors: any;
  };
}) {
  const errors = [];
  const gqlErrors = (params?.errorData?.graphQLErrors ?? []);

  if (gqlErrors.length) {
    gqlErrors.forEach((e: {
      extensions: {
        exception: {};
      };
      message: string;
    }) => {
      errors.push(e.extensions.exception);
    });
  } else {
    //
  }

  yield put({
    type: VALIDATION_ERROR_SUCCESS,
    errors,
  });
}

export function* errorReset() {
  yield put({ type: ERROR_UPDATE_SUCCESS, errors: [] });
}

export default function* error() {
  yield takeLatest(ERROR_PASS_REQUEST, errorPass);
  // @ts-ignore
  yield takeLatest(ERROR_UPDATE_REQUEST, errorUpdate);
  // @ts-ignore
  yield takeLatest(VALIDATION_ERROR_REQUEST, validationError);
  yield takeLatest(ERROR_RESET_REQUEST, errorReset);
}
